import React, { useState, useEffect,useContext, useMemo } from "react";
import TableStyle from "components/Content/Table/TableStyle.module.css";
import { Box, Button, Dialog, DialogTitle, DialogContent, DialogActions, Paper, TextField } from "@mui/material";
import { LoadingButton } from '@mui/lab';
import ButtonStyle from "components/Button/ButtonStyle.module.css";
import { apiGet, apiPost } from "app/Services/ApiService";
import { apiUrls } from "common/ApiUrls";
import AximDropdown from "components/Dropdown/AximDropdown";
import { PrivateRoutesContext } from "app/PrivateRoutesContext";
import SendIcon from '@mui/icons-material/Send';

export default function FeedbackDialog({ portal }) {
  const { companyId, feedback } = useContext(PrivateRoutesContext);

  const [feedbackType, setFeedbackType] = useState("");
  const [feedbackTypes, setFeedbackTypes] = useState([]);
  const [subject, setSubject] = useState("");
  const [description, setDescription] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false)

  const [doDisplayMessage, setDoDisplayMessage] = useState(false);
  const [message, setMessage] = useState("");

  const isFormComplete = useMemo(() => {
    return feedbackType && subject && description;
  },[feedbackType, subject, description]);

  // SUBMIT FORM
  const submitFeedback = () => {
    let feedbackData = {
      feedbackTypeCodeID: feedbackType,
      subject: subject,
      content: description,
    };
    
    setIsSubmitting(true);

    apiPost(apiUrls.postFeedbackForm(companyId), feedbackData)
      .then((res) => {
        setMessage("Thank you for your feedback!");
        setDoDisplayMessage(true);

        setSubject("");
        setDescription("");
        setFeedbackType(feedbackTypes[0].feedbackTypeCodeID);
      })
      .catch((e) => {
        setMessage("Error submitting feedback.");
        setDoDisplayMessage(true);
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  const handleChangeCompany = () => {
    apiGet(apiUrls.getFeedbackType(portal)).then((response) => {
      setFeedbackTypes(response.data);

      if (response.data.length > 0) {
        setFeedbackType(response.data[0].feedbackTypeCodeID);
      }
    });
  }
  
  useEffect(() => {
    handleChangeCompany()
  }, [companyId]);

  useEffect(() => {
    if (feedback.doShow) {
      setDescription('');

      var fType = feedbackTypes.find(t => t.feedbackTypeName === feedback.type);

      if (fType) {
        setFeedbackType(fType.feedbackTypeCodeID);
      }
      else {
        setFeedbackType('');
      }

      if (feedback.subject) {
        setSubject(feedback.subject);
      }
      else {
        setSubject('');
      }
    }
    else {
      feedback.setType('');
      feedback.setSubject('');
      setDoDisplayMessage(false);
    }
  },[feedback.doShow, feedback.type, feedback.subject]);

  return (
    <Dialog
        open={feedback.doShow}
    >
        <DialogTitle id="alert-dialog-title">Feedback</DialogTitle>
        <DialogContent>
            <Box className="row" sx={{maxWidth: "700px"}}>
                <Box className="col-12">
                    <AximDropdown
                        id="feedback-select"
                        label="Select Feedback Type"
                        handleChange={e => setFeedbackType(e.target.value)}
                        value={feedbackType}
                        pairs={feedbackTypes.map(item => ({ value: item.feedbackTypeCodeID, text: item.feedbackTypeName }))}
                        minWidth={"250px"} />
                </Box>
                <Box className="col-12 mb-3" sx={{textAlign: "center"}}>
                    <TextField
                        sx={{"width": "100%"}}
                        id="standard-basic"
                        label="Subject"
                        variant="standard"
                        className={ButtonStyle.feedbackSubject}
                        value={subject}
                        onChange={e => setSubject(e.target.value)}
                    />
                </Box>
                <Box className="col-12 mb-1" sx={{textAlign: "center"}}>
                    <TextField
                        sx={{"width": "100%"}}
                        multiline
                        rows={4}
                        maxRows={16}
                        aria-label="minimum height"
                        placeholder="Feedback Notes"
                        className={ButtonStyle.feedbackTextarea}
                        value={description}
                        onChange={e => setDescription(e.target.value)}
                        color="primary"
                        size="small"
                    />
                </Box>
                {doDisplayMessage ? 
                  <Box className="col-12 mb-1" sx={{textAlign: "left"}}>
                    {message}
                  </Box> : null}
            </Box>
        </DialogContent>
        <DialogActions>
            <LoadingButton
                variant="outlined"
                onClick={() => submitFeedback()}
                disabled={isSubmitting || !isFormComplete}
                loading={isSubmitting}
                loadingPosition="start"
                startIcon={<SendIcon />}
            >
                Submit
            </LoadingButton>
            <Button variant="outlined" onClick={() => feedback.setDoShow(false)} color="primary">
                Close
            </Button>
        </DialogActions>
    </Dialog>
  );
}
